import { Spiner } from "@components/loaders/spiner";
import { StudentHealthRecord } from "@services/dtos/school.dto";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { FaAngleRight, FaChevronDown } from "react-icons/fa";
import { FcFinePrint } from "react-icons/fc";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export const StudentHealthRecordPage = () => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState<string>("10");
  const [kategori, setKategori] = useState<string>("*");
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [
      SchoolService.queries.GET_SCHOOL_STUDENT_HEALTH_RECORD,
      nis,
      kategori,
      limit,
    ],
    queryFn: () => SchoolService.studentHealthRecord(nis, kategori, limit),
  });

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Catatan Kesehatan",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Catatan Kesehatan" });
  }, [setFooter, setHeader, setAppBar]);

  const onOpenDetail = (health: StudentHealthRecord) => {
    navigate(linkPage.SCHOOL_STUDENT_HEALTH_RECORD_DETAIL, { state: health });
  };

  return (
    <div className="card card-style">
      <div className="content mb-0">
        <p className="mb-3">
          Data yang ditampilkan hanya {limit} data terakhir
        </p>

        <div className="input-style has-borders input-style-always-active no-icon mb-4">
          <label htmlFor="form5" className="color-highlight font-500">
            Filter Jumlah ditampilkan
          </label>
          <select
            defaultValue="10"
            onChange={(e) => setLimit(e.target.value)}
            className="bg-theme"
          >
            <option value="default" disabled>
              Filter Jumlah ditampilkan
            </option>
            <option value="10">10 Data Terakhir</option>
            <option value="25">25 Data Terakhir</option>
            <option value="50">50 Data Terakhir</option>
            <option value="100">100 Data Terakhir</option>
          </select>
          <span>
            <i>
              <FaChevronDown />
            </i>
          </span>
        </div>

        <div className="input-style has-borders input-style-always-active no-icon mb-4">
          <label className="color-highlight font-500">Kategori</label>
          <select
            defaultValue="*"
            onChange={(e) => setKategori(e.target.value)}
            className="bg-theme"
          >
            <option value="default" disabled>
              Kategori ditampilkan
            </option>
            <option value="*">Semua</option>
            <option value="Kurus">Kurus</option>
            <option value="Normal">Normal</option>
            <option value="Gemuk">Gemuk</option>
            <option value="Obesitas">Obesitas</option>
          </select>
          <span>
            <i>
              <FaChevronDown />
            </i>
          </span>
        </div>

        {isPending ? (
          <div className="d-flex p-3">
            <Spiner className="!tw-text-gray-200 tw-fill-gray-500 dark:tw-fill-white dark:!tw-text-gray-600 tw-w-8 tw-h-8 m-auto " />
          </div>
        ) : data?.data != null && data.data.length > 0 ? (
          <div className="list-group list-group-flush">
            {data.data.map((item, idx) => (
              <div
                key={idx}
                className="list-group-item tw-bg-inherit d-flex tw-px-0 tw-py-3 tw-border-[rgba(0,0,0,0.05)] dark:tw-border-[rgba(255,255,255,0.05)] tw-cursor-pointer"
                onClick={() => onOpenDetail(item)}
              >
                <div className="rounded-sm tw-w-8 tw-h-8 d-flex tw-flex-none my-auto bg-pink-dark">
                  <MdOutlineHealthAndSafety className="m-auto" size={18} />
                </div>
                <div className="tw-grow mx-3 my-auto d-flex flex-column tw-w-[calc(100vw-140px)]">
                  <span className="tw-font-medium tw-text-sm dark:tw-text-white tw-truncate">
                    {item.kategori}
                  </span>
                  <strong className="tw-font-medium tw-text-[11px] tw-leading-4 tw-text-[#adb5bd] tw-truncate">
                    Tinggi Badan: {item.tinggi_badan} cm | Berat Badan:
                    {item.berat_badan} kg
                  </strong>
                </div>
                <div className="my-auto">
                  <FaAngleRight
                    className="dark:tw-text-white tw-text-gray-500"
                    size={10}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="tw-p-8 text-center ">
            <FcFinePrint size={50} />
            <div>Data tidak ditemukan</div>
          </div>
        )}
      </div>
    </div>
  );
};
